import * as THREE from 'three';
import { global } from '../../core/GlobalState';
import * as SelectionUtils from '../interaction/SelectionUtils';
import { OrbConnectionManager } from './OrbConnectionManager';
import SceneManager from '../../core/SceneManager';
export function makePreviewLine() {
    const geom = new THREE.BufferGeometry().setFromPoints([
        new THREE.Vector3(), new THREE.Vector3()
    ]);
    const mat = new THREE.LineBasicMaterial({ color: 0xffd400, transparent: true, opacity: 0.6 });
    const line = new THREE.Line(geom, mat);
    line.renderOrder = 998;
    SceneManager.getInstance().getScene().add(line);
    return line;
}
export function updatePreviewLine(line, a, b) {
    const attr = line.geometry.getAttribute('position');
    attr.setXYZ(0, a.x, a.y, a.z);
    attr.setXYZ(1, b.x, b.y, b.z);
    attr.needsUpdate = true;
    line.geometry.computeBoundingSphere();
}
export function startConnectDrag(event) {
    const obj = SelectionUtils.getTargetObject(event);
    if (!obj || !obj.parent)
        return;
    const from = global.orbManager.getOrb(obj.parent.uuid);
    if (!from)
        return;
    global.connectDrag.from = from;
    SelectionUtils.applyOutlineToObject(obj, '0xffd400', 3);
    // preview line
    global.connectDrag.previewLine = makePreviewLine();
}
export function updateConnectDrag(event) {
    var _a, _b;
    const drag = global.connectDrag;
    if (!drag.from || !drag.previewLine)
        return;
    if (!event)
        return;
    const fromOrb = drag.from;
    if (!fromOrb.group)
        return;
    const fromPos = fromOrb.group.position.clone();
    const cursorWorld = SelectionUtils.worldPointFromPointer(event.x, event.y);
    // offset start to orb surface (end is just the cursor world point)
    const dir = cursorWorld.clone().sub(fromPos).normalize();
    const r = (_b = (_a = fromOrb.orbConfig) === null || _a === void 0 ? void 0 : _a.radius) !== null && _b !== void 0 ? _b : 100;
    const start = fromPos.clone().add(dir.clone().multiplyScalar(r));
    const end = cursorWorld;
    updatePreviewLine(drag.previewLine, start, end);
}
export function endConnectDrag(event) {
    var _a, _b;
    const drag = global.connectDrag;
    const from = drag.from;
    const line = drag.previewLine;
    if (line) {
        SceneManager.getInstance().getScene().remove(line);
        line.geometry.dispose();
        (_b = (_a = line.material).dispose) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    global.connectDrag.previewLine = null;
    if (!from)
        return;
    SelectionUtils.clearOutline();
    const obj = SelectionUtils.getTargetObject(event);
    if (!obj || !obj.parent) {
        global.connectDrag.from = null;
        return;
    }
    const to = global.orbManager.getOrb(obj.parent.uuid);
    if (to && to.group && from.group && to.group.uuid !== from.group.uuid) {
        const cm = OrbConnectionManager.getInstance();
        if (!cm.has(from, to, undefined, 'edge')) {
            cm.connect({
                a: from,
                b: to,
                type: 'edge',
                profile: { arrows: { end: true } }
            });
        }
        global.chat.addMessage('🔗 Connected orbs (drag).');
    }
    global.connectDrag.from = null;
}
